// extracted by extract-css-chunks-webpack-plugin
module.exports = {"green":"#008254","lime-tint-lp-2":"#E8FDAC","blue-dark":"#02427E","container":"_2ERnCE"};